import React from 'react'
import ImageZoom from './ImageZoom'
import './PreviewModal.scss'

const PreviewModal = ({ item, onClose, t }) => {
  const isPDF = /\.pdf$/i.test(item.FileName)
  return (
      <div className="xmp-gs-pm">
        <div className="xmp-gs-pm-background" onClick={onClose}></div>
        <div className="xmp-gs-pm-body">
          <div className="xmp-gs-pm-close-btn" onClick={onClose}>×</div>
          {!isPDF && <div className="xmp-gs-pm-image"><ImageZoom src={item.Url}/></div>}
          {isPDF && <div className="xmp-gs-pm-pdf">
            {item.IsUploaded ?
              <object data={item.Url + '&inline=true&#view=Fit'}
                      type="application/pdf"
                      width="100%"
                      height="100%">
                <ImageZoom src={item.ThumbnailUrl}/>
              </object> :
              <ImageZoom src={item.ThumbnailUrl}/>}
            </div>}
        </div>
      </div>
  )
}

export default PreviewModal
